// src/contexts/DivisasContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL;

const DivisasContext = createContext();

export const DivisasProvider = ({ children }) => {
  const [divisas, setDivisas] = useState({ bolivares: 0, reales: 0 });
  const [loading, setLoading] = useState(true);

  // ✅ Cargar divisas desde el backend (endpoint público)
  const cargarDivisas = async () => {
    try {
      const response = await fetch(`${API_URL}/servicios/config/divisas`);
      if (!response.ok) throw new Error('Error al cargar divisas');
      const data = await response.json();
      setDivisas({
        bolivares: data.bolivares || 0,
        reales: data.reales || 0,
      });
    } catch (error) {
      console.error('Error al cargar divisas:', error);
      setDivisas({ bolivares: 0, reales: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarDivisas();
  }, []);

  // ✅ Convertir un monto en USD a las otras monedas
  const convertir = (montoUSD) => {
    if (!montoUSD || montoUSD === 0) {
      return { usd: 0, bolivares: 0, reales: 0 };
    }
    return {
      usd: montoUSD,
      bolivares: montoUSD * (divisas.bolivares || 0),
      reales: montoUSD * (divisas.reales || 0),
    };
  };

  // ✅ Formatear números con separador de miles
  const formatNumero = (valor, decimales = 2) => {
    if (valor === null || valor === undefined || isNaN(valor)) return '—';
    return new Intl.NumberFormat('es-AR', {
      minimumFractionDigits: decimales,
      maximumFractionDigits: decimales,
    }).format(valor);
  };

  const tieneDivisas = divisas.bolivares > 0 || divisas.reales > 0;

  return (
    <DivisasContext.Provider
      value={{
        divisas,
        setDivisas,
        cargarDivisas,
        convertir,
        formatNumero,
        tieneDivisas,
        loading,
      }}
    >
      {children}
    </DivisasContext.Provider>
  );
};

export const useDivisas = () => {
  const context = useContext(DivisasContext);
  if (!context) {
    throw new Error('useDivisas debe usarse dentro de un DivisasProvider');
  }
  return context;
};